module.exports = __webpack_public_path__ + "img/popupTitle2.5e2f25d9.png";